import * as React from "react";

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "lucide-react";

import { cn } from "../util.cn";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <AccordionPrimitive.Item
      className={cn("border-b border-gray-7", className)}
      ref={ref}
      {...props}
    />
  );
});
AccordionItem.displayName = "AccordionItem";

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ children, className, ...props }, ref) => {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        className={cn(
          `
            flex flex-1 items-center justify-between gap-1
            py-4 text-1 font-medium transition-all
            [&[data-state=open]>svg]:rotate-180
          `,
          className,
        )}
        ref={ref}
        {...props}
      >
        {children}
        <ChevronDownIcon
          className={`
            size-4 shrink-0 text-gray-11
            transition-transform duration-200
          `}
        />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
});
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ children, className, ...props }, ref) => {
  return (
    <AccordionPrimitive.Content
      className={`
        overflow-hidden text-2
        data-[state=closed]:animate-accordion-up
        data-[state=open]:animate-accordion-down
      `}
      ref={ref}
      {...props}
    >
      <div className={cn("pb-4 pt-0", className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
});
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export {
  Accordion as Root,
  AccordionContent as Content,
  AccordionItem as Item,
  AccordionTrigger as Trigger,
};
